export default __webpack_public_path__ + "static/8-121631f7dc0cb77317f40138476f47f4.png";